import reactComponentLoader from 'scripts/react-component-loader'

import ProgramRulesPage from './ProgramRulesPage'

reactComponentLoader(ProgramRulesPage, '[data-lmcv-program-rules-page]')
